import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TextareaAutosize from 'react-autosize-textarea';
import './TextAreaInput.scss';
var TextAreaInput = /*#__PURE__*/function (_Component) {
  function TextAreaInput(props) {
    var _this;
    _classCallCheck(this, TextAreaInput);
    _this = _callSuper(this, TextAreaInput, [props]);
    _this.state = {
      showExampleText: false
    };
    _this.toggleExampleText = _this.toggleExampleText.bind(_this);
    _this.handleTextSuggestions = _this.handleTextSuggestions.bind(_this);
    return _this;
  }
  _inherits(TextAreaInput, _Component);
  return _createClass(TextAreaInput, [{
    key: "handleTextSuggestions",
    value: function handleTextSuggestions() {
      var _this$props = this.props,
        onAnswerChange = _this$props.onAnswerChange,
        value = _this$props.value,
        textSuggestion = _this$props.textSuggestion;
      var newValue = value ? "".concat(value, " ").concat(textSuggestion) : textSuggestion;
      onAnswerChange(newValue);
    }
  }, {
    key: "toggleExampleText",
    value: function toggleExampleText() {
      this.setState(function (prevState) {
        return {
          showExampleText: !prevState.showExampleText
        };
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        placeholder = _this$props2.placeholder,
        rows = _this$props2.rows,
        value = _this$props2.value,
        onAnswerChange = _this$props2.onAnswerChange,
        error = _this$props2.error,
        textAreaPrompt = _this$props2.textAreaPrompt,
        exampleText = _this$props2.exampleText,
        className = _this$props2.className,
        required = _this$props2.required,
        textPromptClass = _this$props2.textPromptClass,
        textSuggestion = _this$props2.textSuggestion;
      var showExampleText = this.state.showExampleText;
      return /*#__PURE__*/React.createElement("div", {
        className: "proposal-text-area-input body-text-2"
      }, /*#__PURE__*/React.createElement("div", {
        className: "medium-weight ".concat(textPromptClass)
      }, textAreaPrompt), exampleText && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("a", {
        className: "modal-anchor-trigger",
        tabIndex: 0,
        role: "button",
        onClick: this.toggleExampleText,
        id: "show-example-text"
      }, showExampleText ? 'View less' : 'View example')), /*#__PURE__*/React.createElement("div", null, showExampleText && /*#__PURE__*/React.createElement("div", {
        className: "tool-tip"
      }, exampleText))), textSuggestion && /*#__PURE__*/React.createElement("div", {
        className: "body-text-2 mb-4"
      }, "Need help completing this section?\xA0", /*#__PURE__*/React.createElement("a", {
        onClick: this.handleTextSuggestions,
        tabIndex: 0,
        role: "button"
      }, "Add Text Suggestions")), /*#__PURE__*/React.createElement(TextareaAutosize, {
        className: "mt-3 ".concat(className, " ").concat(error && 'with-error'),
        placeholder: placeholder,
        rows: rows,
        value: value,
        required: required,
        onChange: function onChange(e) {
          return onAnswerChange(e.target.value);
        }
      }));
    }
  }]);
}(Component);
TextAreaInput.propTypes = {
  placeholder: PropTypes.string.isRequired,
  rows: PropTypes.number,
  value: PropTypes.string,
  onAnswerChange: PropTypes.func.isRequired,
  error: PropTypes.string,
  textPromptClass: PropTypes.string,
  textAreaPrompt: PropTypes.string,
  exampleText: PropTypes.string,
  className: PropTypes.string,
  required: PropTypes.bool,
  textSuggestion: PropTypes.string
};
TextAreaInput.defaultProps = {
  rows: 2,
  value: '',
  error: null,
  exampleText: null,
  textPromptClass: '',
  textAreaPrompt: 'Tell us more about that.',
  className: 'proposal-text-area',
  required: true,
  textSuggestion: null
};
export default TextAreaInput;